import { MdConfirmationNumber } from 'react-icons/md';

import { EventTierForPublic } from 'legacy/events/types';
import QuantityButtons from '../../../QuantityButtons';
import { useCheckout } from 'features/events/checkout/context';
import { QuantityChangeEvents } from 'features/events/checkout/types';
import { currencyFormat } from 'legacy/common/utils/currency';
import MemberOnlyTierLabel from '../../../MemberOnlyTierLabel';

type Props = {
  tier: EventTierForPublic;
};

const SummaryItem = ({ tier }: Props) => {
  const { tickets, updateTicketTierQuantityAndSave } = useCheckout();

  const isMemberOnlyAccess =
    tier?.requiredAssociationIds?.length > 0 ||
    tier?.requiredOrganizationIds?.length > 0;

  const onTicketQuantityChange = (event: QuantityChangeEvents) => {
    updateTicketTierQuantityAndSave(tier._id, event);
  };

  return (
    <li className="flex flex-col gap-2 not-first:border-t-1 border-neutral-200 py-5">
      <div className="flex align-center">
        <div className="font-bold text-sm py-3 flex-1">{tier.name}</div>
        <div className="w-[40px] h-[40px] bg-neutral-200 flex align-center justify-center rounded-lg overflow-hidden">
          {tier.imageUrl ? (
            <img
              src={tier.imageUrl}
              className="w-full h-full object-cover object-center"
            />
          ) : (
            <MdConfirmationNumber size={20} className="text-neutral-500" />
          )}
        </div>
      </div>
      <div className="flex justify-center align-center">
        <div className="flex flex-1">
          <QuantityButtons
            remainingTicketsForTier={tier.remaining}
            selectedTicketTierQuantity={
              tickets.selectedTicketTiers[tier._id].quantity
            }
            maxTicketsPerTransaction={tickets.maxTicketsPerTransaction}
            onQuantityChange={onTicketQuantityChange}
            totalAmountOfTicketsSelected={tickets.totalAmountOfTicketsSelected}
          />
        </div>
        <div className="font-normal text-sm">{currencyFormat(tier.price)}</div>
      </div>
      {isMemberOnlyAccess && (
        <div className="flex flex-1 flex-col gap-2 items-start pt-2">
          <MemberOnlyTierLabel />
        </div>
      )}
    </li>
  );
};

export default SummaryItem;
